import { render, staticRenderFns } from "./NewSettlement.vue?vue&type=template&id=15efe8c4&scoped=true&"
import script from "./NewSettlement.vue?vue&type=script&lang=js&"
export * from "./NewSettlement.vue?vue&type=script&lang=js&"
import style0 from "./NewSettlement.vue?vue&type=style&index=0&id=15efe8c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15efe8c4",
  null
  
)

export default component.exports